<template>
  <div class="relative overflow-y-hidden">
    <div class="flex justify-between items-center mb-5">
      <h1 class=" text-page-header-font-size headline">
        {{ ___("Pipeline|Header|content") }}
      </h1>
      <svg
        v-if="filterShown == false"
        @click="toggleFilters()"
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6 md:hidden"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 5l7 7-7 7"
        />
      </svg>
      <svg
        v-else
        @click="toggleFilters()"
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6 md:hidden"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </div>
    <Modal v-if="showModal" @close="toggleModal">
      <template v-slot:header>
        <h3 class="text-subheader-font-size font-semibold">
          {{ ___("Pipeline|Confirm order|content") }}
        </h3>
      </template>

      <template v-slot:body>
        <table class="table-auto w-full text-left mb-5 cart-table">
          <thead>
            <tr>
              <th class="border border-primary-color p-2">{{ ___("Pipeline|Article Image|content") }}</th>
              <th class="border border-primary-color p-2">{{ ___("Pipeline|Article Name|content") }}</th>
              <th v-if="isArticlePriceShown" class="border border-primary-color p-2">{{ ___("Pipeline|Unit price|content") }}</th>
              <th class="border border-primary-color p-2"> {{ ___("Pipeline|Quantity|content") }}</th>
              <th v-if="isArticlePriceShown" class="border border-primary-color p-2">{{ ___("Pipeline|Total|content") }} </th>
              <th class="border border-primary-color p-2"></th>
            </tr>
          </thead>
          <tbody>
            <tr  v-for="(cartitem, c) in cart" :key="c+100" >
              <td class="border p-2" :class="cartitem.isShippingCostArticle ? 'ml-2 md:ml-5 block' :''">
                <div
                    v-for="article in cartitem.local_article"
                    :key="article.id"
                    class="h-13"
                  >
                  <template v-if="article.media.length">
                    <template v-for="(media, j) in article.media">
                      <img
                        v-if="article.image_location === 'weclapp' && media.collection_name === 'weclapp_images'"
                        class="w-full object-contain h-13"
                        :src="media.original_url"
                        :alt="media.name"
                      />
                      <img
                        v-else-if="article.image_location === 'local' && media.collection_name === 'main'"
                        class="w-full object-contain h-13"
                        :src="media.original_url"
                        :alt="media.name"
                      />
                    </template>
                  </template>
                  <img
                    v-else-if="defaultArticleImage"
                    :src="'/storage/' + defaultArticleImage"
                    alt="default-article-img"
                    class="w-full object-contain h-13"
                  />
                  <img
                    v-else
                    src="/img/dummyimg.jpg"
                    alt="dummy-img"
                    class="w-full object-contain h-13"
                  />
                </div>
              </td>
              <td class="border p-2">
                <p class=" flex justify-between">
                  {{cartitem.article_name}}
                  <template v-if="checkIfPdfExists(cartitem)">
                    <a :href="checkIfPdfExists(cartitem)" target="_blank">
                      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" 
                      width="20" height="20" viewBox="0 0 172 172" style="fill: #000000" class="inline" >
                        <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                        stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray=""
                        stroke-dashoffset="0" font-family="none" font-weight="none"
                        font-size="none" text-anchor="none" style=" mix-blend-mode: normal; ">
                        <path d="M0,172v-172h172v172z" fill="none"></path>
                        <g fill="#000000">
                          <path d="M86,14.33333c-39.49552,0 -71.66667,32.17115 -71.66667,71.66667c0,39.49552 32.17115,71.66667 71.66667,71.66667c39.49552,0 71.66667,-32.17115 71.66667,-71.66667c0,-39.49552 -32.17115,-71.66667 -71.66667,-71.66667zM86,28.66667c31.74921,0 57.33333,25.58412 57.33333,57.33333c0,31.74921 -25.58412,57.33333 -57.33333,57.33333c-31.74921,0 -57.33333,-25.58412 -57.33333,-57.33333c0,-31.74921 25.58412,-57.33333 57.33333,-57.33333zM78.83333,50.16667v14.33333h14.33333v-14.33333zM78.83333,78.83333v43h14.33333v-43z"
                          ></path>
                        </g>
                        </g>
                      </svg>
                    </a>
                  </template>
                </p>
              </td>
              <td v-if="isArticlePriceShown" class="border p-2"> {{ formatCurrency(cartitem.article_price) }}</td>
              <td class="border p-2">
                <div class="flex flex-row h-10 w-24 rounded-lg relative" v-if="!cartitem.isShippingCostArticle">
                    <button
                      type="number"
                      class="
                        font-semibold
                        bg-primary-color
                        text-primary-text-color
                        border border-primary-color
                        hover:bg-white hover:text-primary-hover-text-color
                        h-full
                        w-20
                        flex
                        rounded-l
                        focus:outline-none
                        cursor-pointer
                      "
                      min="1"
                      @click="decreasequantity(c)"
                    >
                      <span class="m-auto">-</span>
                    </button>
                    <input
                      class="
                        w-12		
                        md:p-2
                        p-1
                        text-xs
                        md:text-base
                        focus:outline-none
                        text-center
                      "
                      name="custom-input-number"
                      min="1"
                      max="999"
                      @change="editArticleCount($event,c)"
                      :value="cartitem.article_quantity < 1 ? cartitem.article_quantity = 1 : cartitem.article_quantity " 
                    />
                    <button
                      type="number"
                      class="
                        font-semibold
                        bg-primary-color
                        text-primary-text-color
                        border border-primary-color
                        hover:bg-white hover:text-primary-hover-text-color
                        h-full
                        w-20
                        flex
                        rounded-r
                        focus:outline-none
                        cursor-pointer
                      "
                      @click="incrementquantity(c)"
                    >
                      <span class="m-auto">+</span>
                    </button>
                </div>
                <p v-else>{{ cartitem.article_quantity < 1 ? cartitem.article_quantity = 1 : cartitem.article_quantity}}</p>
              </td>
              <td v-if="isArticlePriceShown" class="border p-2">
                {{formatCurrency(totalprice(cartitem.article_price,cartitem.article_quantity))}}
              </td>
              <td class="text-center border p-2" >
                <button
                    v-if="!cartitem.isShippingCostArticle"
                    aria-label="Delete Cart Item"
                    type="button "
                    @click="deleteCartItem(c)"
                    class="
                      bg-transparent
                      border-0
                      text-black
                      opacity-5
                      text-3xl
                      leading-none
                      font-semibold
                      outline-none
                      focus:outline-none
                    "
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      />
                    </svg>
                </button>
              </td>
            </tr>
            <tr v-if="isArticlePriceShown" class="font-bold border">
              <tr>
                <td class="border p-2 font-bold " colspan="3">
                {{ ___("Pipeline|Total Amount|content") }}
                </td>
                <td class="border p-2 font-bold " colspan="3">
                  {{ calaculateTotalPrice()}}
                  <span v-if="hasGrossItem && !isGrossZero"> {{ ___("Pipeline|(including taxes)|content", { amount: formatCurrency(calculateTaxAmount(grossTaxAmount,calculateChannelAmount("GROSS"),'GROSS')) }) }}</span>
                </td>
              </tr>
              <tr v-if="hasNetItem && !isNetZero">
                <td class="border p-2 font-bold " colspan="3">
                   {{ ___("Pipeline|Additional taxes|content") }} 
                </td>
                  <td class="border p-2 font-bold " colspan="3">
                    {{formatCurrency(calculateTaxAmount(netTaxAmount,calculateChannelAmount("NET"),'NET')) }}
                  </td>
              </tr>
            </tr>
          </tbody>
        </table>

        <div class="border-t pt-5">
          <label class="subline" for="grid-state">
            {{ ___("Pipeline|Select Delivery Address|content") }}:
          </label>

          <div class="relative mb-3">
            <select
              v-model="selectedAddress"
              id="grid-state"
              name="grid-state"
              class="
                block
                appearance-none
                w-full
                bg-white
                border border-gray-200
                text-gray-700
                py-3
                px-4
                pr-8
                rounded
                leading-tight
                focus:outline-none focus:border-gray-500
              "
            >
              <option
                v-for="(address, i) in data.addresses"
                :key="i"
                :value="address.zipcode"
              >
               {{ deliveryAddress(address)}}
              </option>
            </select>
            <div
              class="
                pointer-events-none
                absolute
                inset-y-0
                right-0
                flex
                items-center
                px-2
                text-gray-700
              "
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
            <div v-for="(slot, index) in [orderConfirmationSlot1, orderConfirmationSlot2, orderConfirmationSlot3, orderConfirmationSlot4]" :key="index" v-if="Object.keys(slot).length > 0"> 
              <div v-if="Object.keys(slot).length > 0" :key="index"> 
                <label class="subline text-sm font-bold mb-2" :for="slot['id']">
                  {{slot['label']}}
                  <span v-if="!slot['required']">
                    ({{___("Pipeline|Optional|content")}}):
                  </span>
                  <span v-else>
                    ({{___("Pipeline|Required|content")}}):
                  </span>
                </label>
                <template v-if="slot['attributeType']=='INTEGER'">
                  <input
                    class="
                      field
                      appearance-none
                      border
                      rounded
                      w-full
                      py-3
                      px-4
                      pr-8
                      text-gray-700
                      leading-tight
                      focus:outline-none
                    "
                    type="number"
                    :id="slot['id']"
                    :name="slot['id']"
                    v-model="slot['numberValue']"
                    :placeholder="slot['label']"
                    @input="handleInput(slot)"
                  /> 

                </template>
                <template v-else-if="slot['attributeType']=='BOOLEAN'">
                <input class="py-3 px-4 pr-8 ml-3"
                        type="checkbox"
                        :id="slot['id']"
                        :name="slot['label']"
                        :value="slot['id']"
                        v-model="
                        slot['booleanValue']
                        "
                      />
                </template>
                <template v-else-if="slot['attributeType']=='LIST'">
                  <div class="relative">
                    <select
                      class="
                        block
                        appearance-none
                        w-full
                        bg-white
                        border border-gray-200
                        text-gray-700
                        py-3
                        px-4
                        pr-8
                        rounded
                        leading-tight
                        focus:outline-none focus:border-gray-500
                      "
                      :name="slot['label']"
                      :id="slot['id']"
                      v-model="
                        slot['selectedValueId']
                      "
                      :placeholder="___('General|Select options|content')"
                      
                    >
                      <option
                        v-for="(value, j) in slot['selectableValues']"
                        :key="j"
                        :value="value.id"
                      >
                        {{ value.value }}
                      </option>
                    </select>
                    <div
                      class="
                        pointer-events-none
                        absolute
                        inset-y-0
                        right-0
                        flex
                        items-center
                        px-2
                        text-gray-700
                      "
                    >
                      <svg
                        class="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path
                          d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                        />
                      </svg>
                    </div>
                  </div>

                </template>
                <template v-else-if="slot['attributeType']=='DATE'">
                  <input
                    class="
                      field
                      appearance-none
                      border
                      rounded
                      w-full
                      py-3
                      px-4
                      pr-8
                      text-gray-700
                      leading-tight
                      focus:outline-none
                      cursor-pointer
                    "
                    type="date"
                    :id="slot['id']"
                    :name="slot['label']"
                    v-model="
                      slot['dateValue']
                    "
                  />
                </template>
                <template v-else-if="slot['attributeType']=='MULTISELECT_LIST'">
                  <multiselect
              class="text-base"
                :options="slot['selectableValues']"
                :multiple="true"
                :clear-on-select="false"
                :preserve-search="true"
                :placeholder="___('General|Select options|content')"
                :selectLabel="___('General|Press enter to select|content')"
                :deselectLabel="___('General|Press enter to remove|content')"
                :selectedLabel="___('General|Selected|content')"
                label="value"
                track-by="id"
                v-model="slot['selectedValues']"
              >
                <template slot="noResult">
                  {{ ___("General|MultiSelectError|content") }}
                </template>
                <template slot="noOptions">
                    {{ ___("General|No Options|content") }}
                  </template>
                <template
                  class="py-3 px-4 pr-8"
                  slot="selection"
                  slot-scope="{ values, isOpen }"
                  ><span
                    class="multiselect__single"
                    v-if="values.length &amp;&amp; !isOpen"
                    >{{ values.length }} {{ ___("General|Options selected|content") }}</span
                  ></template
                >
                  </multiselect>
                  <p class="mt-2">
                    {{ valueString(slot['selectedValues'])}}
                  </p>

                </template>
                <template v-else>
                  <input
                    class="
                      field
                      appearance-none
                      border
                      rounded
                      w-full
                      py-3
                      px-4
                      pr-8
                      text-gray-700
                      leading-tight
                      focus:outline-none
                    "
                    type="text"
                    :name="slot['label']"
                    :id="slot['id']"
                    v-model="slot['stringValue']"
                    :placeholder="slot['label']"
                  /> 
                </template>
              </div>
            </div>
          </div>

          <div class="flex items-start space-x-3 mt-2" v-if="salesPDFPresent">
            <input id="pdf-checkbox" type="checkbox" class="border-gray-300 rounded h-4 w-4 mt-2"  v-model="salesPDFCheckbox" />
            <div class="flex flex-col">
              <p>{{ ___("Pipeline|Pdf Checkbox text|content") }}</p>
              <a class="underline" target="_blank" :href="pdfUrl">{{ ___("Pipeline|Pdf Link|content") }}</a>
            </div>
          </div>
         
          <p class="mt-4">
            *{{
              ___(
                "Pipeline|This is an order request and that is final as it is accepted from|content",
                { team: teamName }
              )
            }}
            <p v-if="checkIfCartItemsHavePdf">
            {{ ___("Pipeline|Additional article terms|content") }}
            </p>
          </p>
          <div v-if="errors.length" class="text-red-700 mt-4">
            <b
              >{{
                ___(
                  "Technical|Error|content"
                )
              }}:</b
            >
            <ul class="list-disc list-inside">
              <li v-for="error in errors" :key="error.id">{{ error }}</li>
            </ul>
          </div>
        </div>
      </template>

      <template v-slot:footer>
        <Btn type="button" @onClick="submitForm"  
        :class="salesPDFPresent  && salesPDFCheckbox != true
                  ? 'cursor-not-allowed '
                  : 'cursor-pointer '
              "
              :disabled="salesPDFPresent && salesPDFCheckbox != true">
          {{ ___("Pipeline|Confirm order|content") }}
        </Btn>
      </template>
    </Modal>

    <div
      v-if="orderconfirmed"
      class="
        text-white
        mt-4
        px-6
        py-4
        border-0
        rounded
        relative
        mb-4
        bg-green-500
      "
    >
      <span class="inline-block align-middle mr-8">
        {{ ___("Pipeline|OrderConfirmation|content") }}
      </span>
      <Btn type="button" @onClick="goToArticles">
        {{ ___("Pipeline|Return to Shop|content") }}
      </Btn>

      <button
        type="button"
        class="
          absolute
          bg-transparent
          text-2xl
          font-semibold
          leading-none
          right-0
          top-0
          mt-6
          mr-6
          outline-none
          focus:outline-none
        "
        @click="closeAlert()"
      >
        <span>×</span>
      </button>
    </div>

    <div v-if="activeSalesChannelPresent"  class="
        text-white
        mt-4
        px-6
        py-4
        border-0
        rounded
        relative
        mb-4
        bg-red-500
      ">
      {{ ___("Pipeline|Active Sales Channel Error|content") }} - {{notOrderedArticle}}
    </div>

    <section>
      <div v-if="filterShown">
        <div class="block md:flex md:flex-wrap md:justify-start items-center mb-3 gap-2	">
          <input
            class="
              relative
              field
              appearance-none
              border
              rounded
              w-full
              md:w-1/4
              py-2
              px-3
              text-gray-700
              leading-tight
              focus:outline-none
              search-wrapper
            "
            type="text"
            v-model="search"
            :placeholder="___('Pipeline|Search|content') + '...'"
          />
          <date-picker
            class="w-full md:mx-5 my-2 md:my-0"
            v-model="datefilter"
            range
            type="date"
            :placeholder="___('Pipeline|Search-date|content') + '...'"
          ></date-picker>
          <ToggleSwitch v-model="toggleValue" v-on:input="shown = !shown" label="Show Images"/>
          <div class="flex items-center lg:ml-5 my-2 lg:my-0">
            <label for="cardOrder" class="mr-3">{{
              ___("Pipeline|Sort|content")
            }}</label>
            <div class="relative">
              <select
                @change="sortTable($event)"
                name="cardOrder"
                id="cardOrder"
                class="
                  w-full
                  appearance-none
                  bg-white
                  border border-gray-200
                  text-gray-700
                  py-3
                  px-4
                  pr-8
                  rounded
                  leading-tight
                  focus:outline-none focus:border-gray-500
                "
              >
                <option value="latest_creation_date">
                  {{ ___("Pipeline|Latest Creation Date|content") }}
                </option>
                <option value="oldest_creation_date">
                  {{ ___("Pipeline|Oldest Creation Date|content") }}
                </option>
                <option value="latest_shipment_date">
                  {{ ___("Pipeline|Latest Shipment Date|content") }}
                </option>
                <option value="oldest_shipment_date">
                  {{ ___("Pipeline|Oldest Shipment Date|content") }}
                </option>
              </select>
              <div
                class="
                  pointer-events-none
                  absolute
                  inset-y-0
                  right-0
                  flex
                  items-center
                  px-2
                  text-gray-700
                "
              >
                <svg
                  class="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path
                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div class="flex items-center lg:ml-5 my-2 lg:my-0">
            <label for="pipelineOrder" class="mr-3">
              {{___("Pipeline|Group by|content")}}:
            </label>
            <div class="relative">
              <select
                @change="orderPipeline($event)"
                name="pipelineOrder"
                id="pipelineOrder"
                class="
                  w-full
                  appearance-none
                  bg-white
                  border border-gray-200
                  text-gray-700
                  py-3
                  px-4
                  pr-8
                  rounded
                  leading-tight
                  focus:outline-none focus:border-gray-500
                "
              >
                <option value="do_not_order">
                  {{___("Pipeline|Do not group|content")}}
                </option>
                <option value="order_by_id">
                  {{___("Pipeline|Group by id|content")}}
                </option>
              </select>
              <div
                class="
                  pointer-events-none
                  absolute
                  inset-y-0
                  right-0
                  flex
                  items-center
                  px-2
                  text-gray-700
                "
              >
                <svg
                  class="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path
                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div class="column-pills" v-if="salesValue || shipmentValue">
          <button
            v-for="(saleButton, i) in salesValue"
            :key="i"
            @click="deleteSalesFilter(i)"
            type="button"
            class="
              sales-pill
              bg-green-900
              text-white text-xs
              rounded-full
              focus:outline-none
              py-2
              px-4
              mb-3
              mr-3
            "
          >
             {{ ___("Status|" + saleButton + "|content") }}
            <span>x</span>
          </button>
          <button
            v-for="(shipmentButton, j) in shipmentValue"
            :key="j + 100"
            @click="deleteShipmentFilter(j)"
            type="button"
            class="
              shipment-pill
              bg-orange-500
              text-white text-xs
              focus:outline-none
              rounded-full
              py-2
              px-4
              mb-3
              mr-3
            "
          >
            {{ ___("Status|" + shipmentButton + "|content") }}
            <span>x</span>
          </button>
        </div>
      </div>
      <div class="filter-pills">
        <button
          @click="datefilter = ''"
          type="button"
          v-if="clearDateFilter(datefilter)"
          class="
            date-pills
            bg-primary-color
            text-white text-xs
            rounded-full
            focus:outline-none
            py-2
            px-4
            mb-3
          "
        >
          {{ convertDate(datefilter[0]) }} ~
          {{ convertDate(datefilter[1]) }}
          <span>x</span>
        </button>
        <button
          @click="search = ''"
          type="button"
          v-if="search"
          class="
            search-pill
            bg-primary-color
            text-white text-xs
            rounded-full
            py-2
            px-4
            mb-3
          "
        >
          {{ search }}
          <span>x</span>
        </button>
      </div>

      <template v-if="piplineOrder=='do_not_order'">
        <div
          class="
            flex
            overflow-x-scroll
            justify-between
            lg:grid
            gap-4
          "
          v-if="filteredSales != null && filteredShipment != null"
          :class="($page.props.isShopShown && $page.props.user.show_shop_view && cart.length > 0) ? ' md:grid-cols-3' : ' md:grid-cols-2'"
        >
          <div
            class="
              bg-secondary-color
              pipeline-card
              flex flex-col
              p-4
            "
            v-if="$page.props.isShopShown && $page.props.user.show_shop_view && cart.length > 0"
          >
            <div class="block xl:flex xl:justify-between flex-none">
              <h3 class="text-subheader-font-size subline">
                1.{{ ___("Pipeline|Cart|content") }}
              </h3>
              <Btn v-if="cart.length > 0" type="button" @onClick="toggleModal">
                {{ ___("Pipeline|Confirm order|content") }}
              </Btn>
            </div>

            <div class="overflow-y-auto" v-if="cart.length > 0">
              <p v-if="isArticlePriceShown">
                {{ ___("Pipeline|Total Amount|content") }} : {{calaculateTotalPrice()}}
                <span v-if="hasNetItem && !isNetZero">
                  {{ ___("Pipeline|(plus taxes)|content", { amount: formatCurrency(calculateTaxAmount(netTaxAmount,calculateChannelAmount("NET"),'NET')) }) }}
                </span>
                <span v-if="hasGrossItem && !isGrossZero">
                  {{ ___("Pipeline|(including taxes)|content", { amount: formatCurrency(calculateTaxAmount(grossTaxAmount,calculateChannelAmount("GROSS"),'GROSS')) }) }}
                </span>
              </p>

              <div
                v-for="(cartitem, i) in cart"
                :key="i"
                class="bg-white shadow-md rounded p-4 border border-white mb-4 mt-2"
                :class="cartitem.isShippingCostArticle ? 'ml-5' :''"
              >
                <div class="flex justify-end mb-3 relative group cursor-pointer"  v-if="!cartitem.isShippingCostArticle">
                  <button
                    aria-label="Delete Cart Item"
                    type="button "
                    @click="deleteCartItem(i)"
                    class="
                      bg-transparent
                      border-0
                      text-black
                      opacity-5
                      text-3xl
                      leading-none
                      font-semibold
                      outline-none
                      focus:outline-none
                    "
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      />
                    </svg>
                  </button>
                  <div
                    class="
                      absolute
                      bottom-0
                      right-0
                      hidden
                      mb-6
                      group-hover:flex
                      flex-col
                      items-end
                    "
                  >
                    <span
                      class="
                        relative
                        z-10
                        p-2
                        text-xs
                        leading-none
                        text-white
                        whitespace-no-wrap
                        bg-black
                        shadow-lg
                      "
                    >
                      {{ ___("General|Delete|content") }}</span
                    >
                    <div
                      class="w-3 h-3 -mt-2 mr-1 transform rotate-45 bg-black"
                    ></div>
                  </div>
                </div>
                <div v-if="shown">
                  <div
                    v-for="article in cartitem.local_article"
                    :key="article.id"
                  >
                  <template v-if="article.media.length">
                    <template v-for="(media, j) in article.media">
                      <img
                        v-if="article.image_location === 'weclapp' && media.collection_name === 'weclapp_images'"
                        class="w-full object-contain my-3 h-56"
                        :src="media.original_url"
                        :alt="media.name"
                      />
                      <img
                        v-else-if="article.image_location === 'local' && media.collection_name === 'main'"
                        class="w-full object-contain my-3 h-56"
                        :src="media.original_url"
                        :alt="media.name"
                      />
                    </template>
                  </template>
                  <img
                    v-else-if="defaultArticleImage"
                    :src="'/storage/' + defaultArticleImage"
                    alt="default-article-img"
                    class="w-full object-contain my-3 h-56"
                  />
                  <img
                    v-else
                    src="/img/dummyimg.jpg"
                    alt="dummy-img"
                    class="w-full object-contain my-3 h-56"
                  />
                  </div>
                </div>

                <div class="xl:flex xl:justify-between mb-3">
                  <h1 class="headline">{{ cartitem.article_name }}</h1>
                  <h2>{{ cartitem.article_number }}</h2>
                </div>
                <div class="mb-3 flex items-center"  v-if="!cartitem.isShippingCostArticle">
                  {{ ___("Pipeline|Quantity|content") }} :
                  <div class="ml-4 flex flex-row h-10 w-24 rounded-lg relative">
                    <button
                      type="number"
                      class="
                        font-semibold
                        bg-primary-color
                        text-primary-text-color
                        border border-primary-color
                        hover:bg-white hover:text-primary-hover-text-color
                        h-full
                        w-20
                        flex
                        rounded-l
                        focus:outline-none
                        cursor-pointer
                      "
                      min="1"
                      @click="decreasequantity(i)"
                    >
                      <span class="m-auto">-</span>
                    </button>
                    <input
                      class="
                        w-12		
                        md:p-2
                        p-1
                        text-xs
                        md:text-base
                        focus:outline-none
                        text-center
                      "
                      name="custom-input-number"
                      min="1"
                      max="999"
                      @change="editArticleCount($event,i)"
                      :value="cartitem.article_quantity < 1 ? cartitem.article_quantity = 1 : cartitem.article_quantity " 
                    />
                    <button
                      type="number"
                      class="
                        font-semibold
                        bg-primary-color
                        text-primary-text-color
                        border border-primary-color
                        hover:bg-white hover:text-primary-hover-text-color
                        h-full
                        w-20
                        flex
                        rounded-r
                        focus:outline-none
                        cursor-pointer
                      "
                      @click="incrementquantity(i)"
                    >
                      <span class="m-auto">+</span>
                    </button>
                  </div>
                </div>

              <div v-if="isArticlePriceShown">
                <p>
                  {{ ___("Pipeline|Unit price|content") }} :
                  {{ formatCurrency(cartitem.article_price) }}
                </p>

                <p>
                  {{ ___("Pipeline|Total|content") }} :
                  <span
                    v-html="
                      formatCurrency(
                        totalprice(
                          cartitem.article_price,
                          cartitem.article_quantity
                        )
                      )
                    "
                  ></span>
                </p>
              </div>
            </div>
            </div>
            <h2 v-else class="text-page-header-font-size my-6">
              {{ ___("Pipeline|EmptyCart|content") }}
            </h2>
          </div>

          <div class="pipeline-card flex flex-col pt-4">
            <div class="flex items-center flex-none">
              <h3 class="text-subheader-font-size subline">
                {{ ($page.props.isShopShown && $page.props.user.show_shop_view && cart.length>0) ? '2.' : ' 1.' }}
                {{ ___("Pipeline|Open Orders|content") }}
              </h3>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-8 w-8 ml-3"
                fill="none"
                viewBox="0 0 24 24"
                stroke="#14532d"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
                />
              </svg>
            </div>
            <Btn
              class="w-full md:w-3/4 flex-none mb-2"
              v-if="checkedBikes.length > 0"
              type="button"
              @onClick="confirmShipmentModal"
            >
              {{ ___("Pipeline|Confirm Shipment|content") }}
            </Btn>
            <multiselect
            class="flex-none text-base"
              v-model="salesValue"
              :options="salesFilter"
              :multiple="true"
              :placeholder="___('Pipeline|Search Sales by status|content')"
              :selectLabel="___('General|Press enter to select|content')"
              :deselectLabel="___('General|Press enter to remove|content')"
              :selectedLabel="___('General|Selected|content')"
              :searchable="false"
            >
              <template v-slot:tag="{ option, remove }">
                <div class="multiselect__tag">
                  <span> {{ ___("Status|" + option + "|content") }}</span>
                  <i
                    class="multiselect__tag-icon"
                    @click.prevent
                    @mousedown.prevent.stop="remove(option, $event)"
                  />
                </div>
              </template>

              <template slot="noResult">
                {{ ___("General|MultiSelectError|content") }}
              </template>
              <template slot="noOptions">
                {{ ___("General|No Options|content") }}
              </template>
              <template slot="option" slot-scope="props">
                {{ ___("Status|" + props.option + "|content") }}
              </template>
              <template slot="selection" slot-scope="{ values, isOpen }">
                <span
                  class="multiselect__single"
                  v-if="values.length &amp;&amp; !isOpen"
                  >{{ values.length }}  {{ ___("General|Options selected|content") }} </span
                ></template
              >
            </multiselect>

            <div
              class="list-group kanban-column overflow-y-auto mt-6"
              :list="filteredSales"
              group="tasks"
            >
                <SalesOrderTaskCard 
                v-for="task in filteredSales"
                  :key="task.id"
                  :task="task"
                  :shown="shown"
                  :search="search"
                  :teamName="teamName"
                  :max_shipment_article_items="max_shipment_article_items"
                  :defaultArticleImage="defaultArticleImage"
                  :salesBillofItemForPipeline="salesBillofItemForPipeline"
                  :hideExpectedDates="hideExpectedDates"
                  @sendBike="addBike($event)"
                  @updateBike="updateBike($event)"
                  @sendSearch="searchLinkedCards($event)"
                  :shipmentCount="shipmentCount()"
                  ref="usernameInput"
                  class="task-card salescard">
              </SalesOrderTaskCard>
            </div>
          </div>

          <div class="pipeline-card flex flex-col pt-4">
            <div class="flex items-center flex-none">
              <h3 class="text-subheader-font-size subline">
                {{ ($page.props.isShopShown && $page.props.user.show_shop_view && cart.length>0) ? '3.' : ' 2.' }}
                {{ ___("Pipeline|Shipment|content") }}
              </h3>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-8 w-8 ml-3 transform rotate-45"
                fill="none"
                viewBox="0 0 24 24"
                stroke="#ed8936"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                />
              </svg>
            </div>
            <multiselect
            class="flex-none text-base"
              v-if="filteredShipment.length > 0"
              v-model="shipmentValue"
              :options="shipmentFilter"
              :multiple="true"
              :placeholder="___('Pipeline|Search Shipment by status|content')"
              :selectLabel="___('General|Press enter to select|content')"
              :deselectLabel="___('General|Press enter to remove|content')"
              :selectedLabel="___('General|Selected|content')"
              :searchable="false"
            >
              <template v-slot:tag="{ option, remove }">
                <div class="multiselect__tag">
                  <span>  {{ ___("Status|" + option + "|content") }}</span>
                  <i
                    class="multiselect__tag-icon"
                    @click.prevent
                    @mousedown.prevent.stop="remove(option, $event)"
                  />
                </div>
              </template>
              <template slot="noResult">
                {{ ___("General|MultiSelectError|content") }}
              </template>
              <template slot="noOptions">
                {{ ___("General|No Options|content") }}
              </template>
              <template slot="option" slot-scope="props">
                {{ ___("Status|" + props.option + "|content") }}
              </template>
              <template slot="selection" slot-scope="{ values, isOpen }">
                <span
                  class="multiselect__single"
                  v-if="values.length &amp;&amp; !isOpen"
                  >{{ values.length }}  {{ ___("General|Options selected|content") }} </span
                ></template
              >
            </multiselect>

            <div
              v-if="filteredShipment.length > 0"
              class="list-group kanban-column overflow-y-auto mt-6"
              :list="filteredShipment"
              group="tasks"
            >
                <ShipmentTaskCardVue 
                  v-for="task in filteredShipment"
                  :key="task.id"
                  :task="task"
                  :search="search"
                  :shown="shown"
                  :teamName="teamName"
                  :defaultArticleImage="defaultArticleImage"
                  :includeShipmentTrackingLink ="includeShipmentTrackingLink"
                  :isTrackingLinkAssemblyEnabled ="isTrackingLinkAssemblyEnabled"
                  :trackingVariable ="trackingVariable"
                  :salesBillofItemForPipeline="salesBillofItemForPipeline"
                  :hideExpectedDates="hideExpectedDates"
                  :pipelineShippedDate="pipelineShippedDate"
                  class="task-card shipmentcard">
                </ShipmentTaskCardVue>
            </div>
            <p v-else class="text-lg md:text-portal-fontsize mt-6">
              {{ ___("Pipeline|OldShipments|content",{ shipmentdays: shipmentDays }) }}
            </p>
          </div>
        </div>
        <div class="p-6 bg-white shadow-md sm:rounded-lg" v-else>
          <h2 class="text-4xl font-medium text-black">
            {{ ___("Pipeline|No Orders found|content") }}
          </h2>
        </div>
      </template>
      <template v-else>
        <div class="
          flex
          overflow-x-scroll
          justify-between
          lg:grid
          gap-4
        "  :class="($page.props.isShopShown && $page.props.user.show_shop_view && cart.length > 0) ? ' md:grid-cols-3' : ' md:grid-cols-2'"
        >
      <div
          class="
            bg-secondary-color
            pipeline-card
            flex flex-col
            p-4
          "
          v-if="$page.props.isShopShown && $page.props.user.show_shop_view && cart.length > 0"
        >
          <div class="block xl:flex xl:justify-between flex-none">
            <h3 class="text-subheader-font-size subline">
              1.{{ ___("Pipeline|Cart|content") }}
            </h3>
            <Btn v-if="cart.length > 0" type="button" @onClick="toggleModal">
              {{ ___("Pipeline|Confirm order|content") }}
            </Btn>
          </div>

          <div class="overflow-y-auto" v-if="cart.length > 0">
            <p v-if="isArticlePriceShown">
                {{ ___("Pipeline|Total Amount|content") }} : {{calaculateTotalPrice()}}
                <span v-if="hasNetItem && !isNetZero">
                  {{ ___("Pipeline|(plus taxes)|content", { amount: formatCurrency(calculateTaxAmount(netTaxAmount,calculateChannelAmount("NET"),'NET')) }) }}
                </span>
                <span v-if="hasGrossItem && !isGrossZero">
                  {{ ___("Pipeline|(including taxes)|content", { amount: formatCurrency(calculateTaxAmount(grossTaxAmount,calculateChannelAmount("GROSS"),'GROSS')) }) }}
                </span>
              </p>

            <div
              v-for="(cartitem, i) in cart"
              :key="i"
              class="bg-white shadow-md rounded p-4 border border-white mb-4 mt-2"
              :class="cartitem.isShippingCostArticle ? 'ml-5' :''"
            >
              <div class="flex justify-end mb-3 relative group cursor-pointer" v-if="!cartitem.isShippingCostArticle">
                <button
                  aria-label="Delete Cart Item"
                  type="button "
                  @click="deleteCartItem(i)"
                  class="
                    bg-transparent
                    border-0
                    text-black
                    opacity-5
                    text-3xl
                    leading-none
                    font-semibold
                    outline-none
                    focus:outline-none
                  "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                    />
                  </svg>
                </button>
                <div
                  class="
                    absolute
                    bottom-0
                    right-0
                    hidden
                    mb-6
                    group-hover:flex
                    flex-col
                    items-end
                  "
                >
                  <span
                    class="
                      relative
                      z-10
                      p-2
                      text-xs
                      leading-none
                      text-white
                      whitespace-no-wrap
                      bg-black
                      shadow-lg
                    "
                  >
                    {{ ___("General|Delete|content") }}</span
                  >
                  <div
                    class="w-3 h-3 -mt-2 mr-1 transform rotate-45 bg-black"
                  ></div>
                </div>
              </div>
              <div v-if="shown">
                <div
                  v-for="article in cartitem.local_article"
                  :key="article.id"
                >
                <template v-if="article.media.length">
                  <template v-for="(media, j) in article.media">
                    <img
                      v-if="article.image_location === 'weclapp' && media.collection_name === 'weclapp_images'"
                      class="w-full object-contain my-3 h-56"
                      :src="media.original_url"
                      :alt="media.name"
                    />
                    <img
                      v-else-if="article.image_location === 'local' && media.collection_name === 'main'"
                      class="w-full object-contain my-3 h-56"
                      :src="media.original_url"
                      :alt="media.name"
                    />
                  </template>
                </template>
                <img
                  v-else-if="defaultArticleImage"
                  :src="'/storage/' + defaultArticleImage"
                  alt="default-article-img"
                  class="w-full object-contain my-3 h-56"
                />
                <img
                  v-else
                  src="/img/dummyimg.jpg"
                  alt="dummy-img"
                  class="w-full object-contain my-3 h-56"
                />
                </div>
              </div>

              <div class="xl:flex xl:justify-between mb-3">
                <h1 class="headline">{{ cartitem.article_name }}</h1>
                <h2>{{ cartitem.article_number }}</h2>
              </div>
              <div class="mb-3 flex items-center" v-if="!cartitem.isShippingCostArticle">
                {{ ___("Pipeline|Quantity|content") }} :
                <div class="ml-4 flex flex-row h-10 w-24 rounded-lg relative">
                  <button
                    type="number"
                    class="
                      font-semibold
                      bg-primary-color
                      text-primary-text-color
                      border border-primary-color
                      hover:bg-white hover:text-primary-hover-text-color
                      h-full
                      w-20
                      flex
                      rounded-l
                      focus:outline-none
                      cursor-pointer
                    "
                    min="1"
                    @click="decreasequantity(i)"
                  >
                    <span class="m-auto">-</span>
                  </button>
                  <input
                    class="
                    w-12		
                      md:p-2
                      p-1
                      text-xs
                      md:text-base
                      focus:outline-none
                      text-center
                    "
                    name="custom-input-number"
                    min="1"
                    max="999"
                    @change="editArticleCount($event,i)"
                    :value="cartitem.article_quantity < 1 ? cartitem.article_quantity = 1 : cartitem.article_quantity " 
                  />
                  <button
                    type="number"
                    class="
                      font-semibold
                      bg-primary-color
                      text-primary-text-color
                      border border-primary-color
                      hover:bg-white hover:text-primary-hover-text-color
                      h-full
                      w-20
                      flex
                      rounded-r
                      focus:outline-none
                      cursor-pointer
                    "
                    @click="incrementquantity(i)"
                  >
                    <span class="m-auto">+</span>
                  </button>
                </div>
              </div>

            <div v-if="isArticlePriceShown">
              <p>
                {{ ___("Pipeline|Unit price|content") }} :
                {{ formatCurrency(cartitem.article_price) }}
              </p>

              <p>
                {{ ___("Pipeline|Total|content") }} :
                <span
                  v-html="
                    formatCurrency(
                      totalprice(
                        cartitem.article_price,
                        cartitem.article_quantity
                      )
                    )
                  "
                ></span>
              </p>
            </div>
          </div>
          </div>
          <h2 v-else class="text-page-header-font-size my-6">
            {{ ___("Pipeline|EmptyCart|content") }}
          </h2>
      </div>
      <div class="swimlane col-span-2 pt-4">
        <div class="flex justify-between lg:grid gap-4 md:grid-cols-2">
          <div class="group-width">
            <div class="flex items-center flex-none">
              <h3 class="text-subheader-font-size subline">
                {{ ($page.props.isShopShown && $page.props.user.show_shop_view && cart.length>0) ? '2.' : ' 1.' }}
                {{ ___("Pipeline|Open Orders|content") }}
              </h3>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-8 w-8 ml-3"
                fill="none"
                viewBox="0 0 24 24"
                stroke="#14532d"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
                />
              </svg>
            </div>
            <Btn
              class="w-full md:w-3/4 flex-none mb-2"
              v-if="checkedBikes.length > 0"
              type="button"
              @onClick="confirmShipmentModal"
            >
              {{ ___("Pipeline|Confirm Shipment|content") }}
            </Btn>
            <multiselect
            class="flex-none text-base"
              v-model="salesValue"
              :options="salesFilter"
              :multiple="true"
              :placeholder="___('Pipeline|Search Sales by status|content')"
              :selectLabel="___('General|Press enter to select|content')"
              :deselectLabel="___('General|Press enter to remove|content')"
              :selectedLabel="___('General|Selected|content')"
              :searchable="false"
            >
              <template v-slot:tag="{ option, remove }">
                <div class="multiselect__tag">
                  <span> {{ ___("Status|" + option + "|content") }}</span>
                  <i
                    class="multiselect__tag-icon"
                    @click.prevent
                    @mousedown.prevent.stop="remove(option, $event)"
                  />
                </div>
              </template>

              <template slot="noResult">
                {{ ___("General|MultiSelectError|content") }}
              </template>
              <template slot="noOptions">
                {{ ___("General|No Options|content") }}
              </template>
              <template slot="option" slot-scope="props">
                {{ ___("Status|" + props.option + "|content") }}
              </template>
              <template slot="selection" slot-scope="{ values, isOpen }">
                <span
                  class="multiselect__single"
                  v-if="values.length &amp;&amp; !isOpen"
                  >{{ values.length }}  {{ ___("General|Options selected|content") }} </span
                ></template
              >
            </multiselect>
          </div>
          <div class="group-width">
            <div class="flex items-center flex-none">
            <h3 class="text-subheader-font-size subline">
              {{ ($page.props.isShopShown && $page.props.user.show_shop_view && cart.length>0) ? '3.' : ' 2.' }}
              {{ ___("Pipeline|Shipment|content") }}
            </h3>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-8 w-8 ml-3 transform rotate-45"
              fill="none"
              viewBox="0 0 24 24"
              stroke="#ed8936"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
              />
            </svg>
          </div>
          <multiselect
          class="flex-none text-base"
            v-if="filteredShipment.length > 0"
            v-model="shipmentValue"
            :options="shipmentFilter"
            :multiple="true"
            :placeholder="___('Pipeline|Search Shipment by status|content')"
            :selectLabel="___('General|Press enter to select|content')"
            :deselectLabel="___('General|Press enter to remove|content')"
            :selectedLabel="___('General|Selected|content')"
            :searchable="false"
          >
            <template v-slot:tag="{ option, remove }">
              <div class="multiselect__tag">
                <span>  {{ ___("Status|" + option + "|content") }}</span>
                <i
                  class="multiselect__tag-icon"
                  @click.prevent
                  @mousedown.prevent.stop="remove(option, $event)"
                />
              </div>
            </template>
            <template slot="noResult">
              {{ ___("General|MultiSelectError|content") }}
            </template>
            <template slot="noOptions">
              {{ ___("General|No Options|content") }}
            </template>
            <template slot="option" slot-scope="props">
               {{ ___("Status|" + props.option + "|content") }}
            </template>
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }}  {{ ___("General|Options selected|content") }} </span
              ></template
            >
          </multiselect>
          </div>
        </div>
        <div class="pipeline-card overflow-y-scroll">
          <div v-for="(groupedTask,orderId) in groupedSalesAndShipmentTasks" :key="orderId" class="py-4 border-b border-gray-500	">

            <h3>{{ ___("Pipeline|Order id|content") }}: {{  groupedTask.orderId }}</h3>
            <p v-if="groupedTask.orderNumberAtCustomer">{{ ___("Pipeline|Number at Customer|content") }}: {{  groupedTask.orderNumberAtCustomer }}</p>


            <div class="grid gap-4 grid-cols-2">
              <div class="flex flex-col pt-4 group-width">
                <SalesOrderTaskCard
                v-if="groupedTask.sales"
                :key="groupedTask.sales.id"
                :task="groupedTask.sales"
                :search="search"
                :shown="shown"
                :teamName="teamName"
                :max_shipment_article_items="max_shipment_article_items"
                :defaultArticleImage="defaultArticleImage"
                :salesBillofItemForPipeline="salesBillofItemForPipeline"
                @sendBike="addBike($event)"
                @updateBike="updateBike($event)"
                @sendSearch="searchLinkedCards($event)"
                :shipmentCount="shipmentCount()"
                ref="usernameInput"
                class="task-card salescard"
              ></SalesOrderTaskCard>
              
              </div>
              <div class="flex flex-col pt-4 group-width">
                <div v-for="shipmentTask in groupedTask.shipments" :key="shipmentTask.id">
                    <ShipmentTaskCardVue
                      :task="shipmentTask"
                      :search="search"
                      :shown="shown"
                      :teamName="teamName"
                      :defaultArticleImage="defaultArticleImage"
                      :includeShipmentTrackingLink="includeShipmentTrackingLink"
                      :isTrackingLinkAssemblyEnabled="isTrackingLinkAssemblyEnabled"
                      :trackingVariable="trackingVariable"
                      :salesBillofItemForPipeline="salesBillofItemForPipeline"
                      class="task-card shipmentcard"
                    ></ShipmentTaskCardVue>

                </div>
              </div>
            </div> 
          </div>
        </div> 
      </div>
      
      </div>
      </template>
    </section>

   
    <Modal v-if="showCreateShipmentModal" @close="closeCreateShipmentModal" :data="Message">
      <template v-slot:header>
        <h3 class="text-subheader-font-size font-semibold">
          {{ ___("General|ModalHeader|content") }}
        </h3>
      </template>
      <template v-slot:body >
        <div v-if="shipmentError">
          <h4 class="font-semibold">
            {{ ___("Shipment|Shipment Status|content") }}
          </h4>
          <div v-if="status == 'error'">
              <div class="mt-4 text-red-900" v-for="(error, i) in Message" :key="i">
                <p>{{ error.error }}</p>
                <div v-for="(messages, j) in error.messages" :key="j">
                  <p>{{ messages.message }}</p>
                </div>
              </div>
          </div>
          <div v-else class="mt-4 text-green-900">
              {{ Message[0] }}
          </div>
        </div>
        <div v-else>
          <div class="bg-white bg-opacity-75 relative w-full" v-if="showloader">
          <div class="spinner relative flex self-center items-center justify-center w-full h-full p-8">
            <div class="w-12 h-12 rounded-full absolute border-8 border-solid border-primary-color-200">
            </div>
            <div class="w-12 h-12 absolute rounded-full animate-spin border-8 border-solid border-primary-color border-t-transparent">
            </div>
          </div>
          </div>
          <div class="overflow-x-scroll scrollbar" v-else>
            <table class="table-auto w-full mb-2">
              <thead>
                <tr>
                  <th class="p-2 capitalize text-black border border-primary-color table-cell min-w-12">
                    <svg xmlns="http://www.w3.org/2000/svg"
                                              fill="none"
                                              viewBox="0 0 24 24"
                                              stroke-width="1.5"
                                              stroke="currentColor"
                                              class="h-5 w-5 inline-block mb-1"
                                          >
                                              <path
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
                                              />
                    </svg>
                    {{___("General|Order number|content")}}
                  </th>
                  <th class="p-2 capitalize text-black border border-primary-color table-cell min-w-12">
                    <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              fill="none"
                                              viewBox="0 0 24 24"
                                              stroke="currentColor"
                                              class="h-5 w-5 inline-block mb-1"
                                          >
                                              <path
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                  d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
                                              ></path>
                    </svg>
                    {{ ___("Orders|Article Id|content") }}
                  </th>
                  <th class="p-2 capitalize text-black border border-primary-color table-cell min-w-12">
                    <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              fill="none"
                                              viewBox="0 0 24 24"
                                              stroke-width="1.5"
                                              stroke="currentColor"
                                              class="h-5 w-5 inline-block mb-1"
                                          >
                                              <path
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
                                              />
                    </svg>
                    {{ ___("Orders|Article Name|content") }}
                  </th>
                  <th class="p-2 capitalize text-black border border-primary-color table-cell min-w-12" >
                    <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              fill="none"
                                              viewBox="0 0 24 24"
                                              stroke-width="1.5"
                                              stroke="currentColor"
                                              class="h-5 w-5 inline-block mb-1"
                                          >
                                              <path
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"
                                              />
                    </svg>
                    {{ ___("Warehouse|Quantity|content") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, key) in checkedBikes" :key="key" 
                class="text-sm lg:text-base shadow-md lg:shadow-none hover:bg-gray-300 bg-white border border-b table-row flex-row flex-no-wrap mb-0 cursor-pointer">
                <td class="w-full lg:w-auto p-2 lg:p-4 text-gray-800 text-center border border-b table-cell relative lg:static">
                  {{ item.salesOrderNumber }}
                </td>
                <td class="w-full lg:w-auto p-2 lg:p-4 text-gray-800 text-center border border-b table-cell relative lg:static">
                  {{ item.articleId }}
                </td>
                <td class="w-full lg:w-auto p-2 lg:p-4 text-gray-800 text-center border border-b table-cell relative lg:static">
                  {{ item.articleName }}
                </td>
                <td class="w-full lg:w-auto p-2 lg:p-4 text-gray-800 text-center border border-b table-cell relative lg:static">
                  {{ item.shipableItems }}
                </td>
              </tr>
            </tbody>
            </table>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <Btn type="button" 
        @onClick="confirmShipment"
        :class="showloader ? 'cursor-not-allowed ' : 'cursor-pointer '"  
        :disabled="showloader"
        >
                {{ ___("Pipeline|Confirm Shipment|content") }}
        </Btn>
        </template>
    </Modal>
  </div>
</template>

<script>
import Draggable from "vuedraggable";
import ToggleSwitch from "@/Components/ToggleSwitch";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { FormatCurrency } from "../../mixin/formatCurrency";
import Axios from "axios";
import Layout from "@/Shared/Layout";
import Multiselect from "vue-multiselect";
import Modal from "@/Components/Modal";
import Btn from "@/Components/Btn";
import ShipmentTaskCardVue from "../Shared/ShipmentTaskCard.vue";
import SalesOrderTaskCard from "../Shared/SalesOrderTaskCard.vue";
import { MainPipeline } from "../../mixin/mainPipeline";

export default {
  name: "Pipeline",
  components: {
    Draggable,
    ToggleSwitch,
    DatePicker,
    Multiselect,
    Modal,
    Btn,
    SalesOrderTaskCard,
    ShipmentTaskCardVue
  },
  layout: Layout,
  mixins: [FormatCurrency,MainPipeline],
  props: {
    sales: Array,
    shipment: Array,
    cart: Array,
    data: Object,
    max_shipment_article_items: String,
    defaultArticleImage: String,
    salesFilter: Array,
    shipmentFilter: Array,
    teamName: String,
    confettiColors: Array,
    isArticlePriceShown:Boolean,
    shipmentDays:String,
    includeShipmentTrackingLink :Boolean,
    isTrackingLinkAssemblyEnabled : Boolean,
    trackingVariable: String,
    salesBillofItemForPipeline:String,
    showconfetti: Boolean,
    salesPDFPresent: Boolean,
    pdfUrl:String,
    grossTaxAmount:String,
    netTaxAmount:String,
    hasNetItem:Boolean,
    hasGrossItem:Boolean,
    hideExpectedDates:Boolean,
    pipelineShippedDate:String,
    orderConfirmationSlot1: Object,
    orderConfirmationSlot2: Object,
    orderConfirmationSlot3: Object,
    orderConfirmationSlot4: Object,
  },
  data() {
    return {
      arrReceived: [],
      shown: false,
      toggleValue: false,
      showModal: false,
      selectedAddress: this.data.addresses[0].zipcode,
      ordernumbercustomer: "",
      commission: "",
      errors: [],
      orderconfirmed: false,
      datefilter: [null, null],
      checkedBikes: [],
      shipmentError: false,
      Message: "",
      status: "",
      filterShown: false,
      salesValue: this.checkIfSalesFilterPresent(),
      shipmentValue: [],
      search:"",
      activeSalesChannelPresent: false,
      notOrderedArticle:[],
      showCreateShipmentModal:false,
      showloader:false,
      salesPDFCheckbox: false,
      piplineOrder:'do_not_order',
      isNetZero : false,
      isGrossZero : false
    };
  },
  created() {
    this.showFilters();
  },
  methods: {
    showFilters() {
      if (window.innerWidth >= 768) {
        this.filterShown = true;
      } else {
        return;
      }
    },
    toggleFilters() {
      this.filterShown = !this.filterShown;
    },
    addBike(values) {
      const { data,isAddingItem } = values;

      const index = this.checkedBikes.findIndex((bike) =>
      bike.orderId === data.orderId 
       && bike.articleId === data.articleId 
       &&  bike.orderItemId === data.orderItemId 
       && bike.salesOrderNumber === data.salesOrderNumber );

      if(isAddingItem){
        index === -1 ? this.checkedBikes.push(data) : this.checkedBikes[index] = data;
      }
      else{
        index !== -1 && this.checkedBikes.splice(index, 1);
      }
    },
    updateBike(values){
      const { itemToUpdate} = values;
      const itemIndex = this.checkedBikes.findIndex(obj => obj.orderId === itemToUpdate.orderId && obj.articleId === itemToUpdate.articleId  && obj.salesOrderNumber === itemToUpdate.salesOrderNumber);
   
      if (itemIndex !== -1) {
        this.checkedBikes[itemIndex].shipableItems = itemToUpdate.shipableItem;
      }
    },
    searchLinkedCards(searchValue) {
      this.search = searchValue;
    },
    closeCreateShipmentModal(){
      this.showCreateShipmentModal =!this.showCreateShipmentModal;
      if(this.shipmentError){
        this.$inertia.get("/pipeline");
      }
    },
    confirmShipmentModal(){
      this.showCreateShipmentModal =!this.showCreateShipmentModal;
    },
    confirmShipment() {
      this.showloader = !this.showloader;
      Axios.post("/createshipment", this.checkedBikes)
        .then((res) => {
          let message = res["data"];
          if (message[0] == "Shipment created successfully") {
            this.shipmentError = !this.shipmentError;
            this.Message = message;
            this.status = "success";
          } else {
            this.shipmentError = !this.shipmentError;
            this.Message = message;
            this.status = "error";
          }
        })
        .catch((error) => {
          let messageError = error["data"];
          // return error;
        });
    },
    calculateTotal(index) {
      const item = this.cart[index];
      item.total_price = item.article_quantity * item.article_price;
    },
    deleteCartItem(index) {
      this.$inertia.post("/deleteitem", 
      {
        item: this.cart[index],
        view: "pipeline"
      });
    },
    toggleModal() {
      this.showModal = !this.showModal;
      this.errors = [];
    },
    submitForm() {
      const data = {
        selectedAddress: this.selectedAddress,
        cart: this.cart,
        showConfetti : this.showconfetti,
        view:"pipeline",
        orderConfirmationSlot1: this.orderConfirmationSlot1,
        orderConfirmationSlot2: this.orderConfirmationSlot2,
        orderConfirmationSlot3: this.orderConfirmationSlot3,
        orderConfirmationSlot4: this.orderConfirmationSlot4,
      };

        this.checkForm();

        if(this.errors.length ==0){
          this.$inertia.post("/confirmcartorder", data,{
            onSuccess: (response) => {
              if (this.$page.props.showConfetti) {
                return Promise.all([
                  this.$confetti.start({
                    windSpeedMax: 5,
                    defaultDropRate: 20,
                    defaultColors: this.confettiColors,
                  }),
                  this.orderconfirmed = true,
                  this.activeSalesChannelPresent= this.$page.props.isActiveSalesChannelPresent,
                  this.notOrderedArticle = this.getNotOrderedArticle(),
                  setTimeout(() => {
                    this.$confetti.stop();
                    this.orderconfirmed = false;
                    this.activeSalesChannelPresent= false;
                  }, 6000),
                ]);
              } else {
                return Promise.all([
                  this.orderconfirmed = true,
                  this.activeSalesChannelPresent= this.$page.props.isActiveSalesChannelPresent,
                  this.notOrderedArticle = this.getNotOrderedArticle(),
                  setTimeout(() => {
                    this.orderconfirmed = false;
                    this.activeSalesChannelPresent= false;
                  }, 6000),
                ]);
              }
              
      
            },
          });
        }
    },
    closeAlert() {
      this.orderconfirmed = false;
      this.$confetti.stop();
    },
    goToArticles() {
      this.closeAlert();
      this.$inertia.get("/articles");
    },
    checkForm() {
      this.errors = [];

      if (!this.selectedAddress && !this.selectedAddress) {
        this.errors.push(this.___("Pipeline|Delivery address required|content"));
      }

      const checkAndPushError = (slot) => {
        if (slot['required']) {
          attributeTypeChecks(slot);
        }
      };

      const attributeTypeChecks = (slot) => {
        if (
          (slot['attributeType'] === 'INTEGER' && slot['numberValue'] === '') ||
          (slot['attributeType'] === 'BOOLEAN' && slot['booleanValue'] === '') ||
          (slot['attributeType'] === 'DATE' && slot['dateValue'] === '') ||
          (slot['attributeType'] === 'MULTISELECT_LIST' && !slot['selectedValues'].length >0) ||
          (slot['attributeType'] === 'STRING' && slot['stringValue'] === '') ||
          (slot['attributeType'] === 'LIST' && slot['selectedValueId'] === '')
        ) {
          this.errors.push(slot['label'] + ' is required');
        }
        // Add more attributeType-specific checks as needed
      };

      for (let i = 1; i <= 4; i++) {
        const slot = this['orderConfirmationSlot' + i];
        checkAndPushError(slot);
      }
      
    },
    calculateChannelAmount(salesChannelType) {
      return this.cart.reduce((total, element) => {
        if (
          (salesChannelType === "NET" && element.sales_channel.startsWith("NET")) ||
          (salesChannelType === "GROSS" && !element.sales_channel.startsWith("NET"))
        ) {
          total += element.article_price * element.article_quantity;
        }
        return total;
      }, 0);
    },
    calculateTaxAmount(taxAmount, amount ,type) {
        const totalPrice = amount;
        let calculatedAmount = 0;
        if(type == 'NET' ){
          calculatedAmount = totalPrice * (taxAmount/100);
          this.isNetZero = calculatedAmount == 0 ? true: false;
        }
        else
        {
          calculatedAmount = totalPrice * ((taxAmount/100)/(1+(taxAmount/100))) ;
          this.isGrossZero = calculatedAmount == 0 ? true: false;
        }
        
        return calculatedAmount;
    },
    calaculateTotalPrice() {
      let total = 0;      
      this.cart.forEach((element) => {
        total += element.article_price * element.article_quantity;
      });
      return this.formatCurrency(total.toFixed(2));
    },
    convertDate(str) {
      var date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    },
    totalprice(p1, p2) {
      let total = p1 * p2;
      return total.toFixed(2);
    },
    decreasequantity(index) {
      const item = this.cart[index];
      if (item.article_quantity > 1) {
        this.$inertia.post(
        "/decrementitem",
        [this.cart[index]],
        {
          onError: errors => {
             return error;
          },
        }
      );
      }
    },
    incrementquantity(index) {
      if(this.cart[index]['article_quantity'] <= 999){
        this.$inertia.post(
            "/incrementitem",
            [this.cart[index]],
            {
              onError: errors => {
                return error;
              },
            }
          );
        }
    },
    editArticleCount(event,index){
      if( Number(event.target.value) >=  Number(event.target.min)) {
        const data = {
        cart: this.cart[index],
        value: Number(event.target.value) <= 999 ? Number(event.target.value) : 999,
      };
        this.$inertia.post(
        "/editcartitem",
        data,
        {
          onError: errors => {
             return error;
          },
        }
      );
      }
      else{
        const data = {
        cart: this.cart[index],
        value: 1,
      };
      this.$inertia.post(
        "/editcartitem",
        data,
        {
          onError: errors => {
             return error;
          },
        }
      );
      }
    },
    sortTable(event) {
      let direction = event.target.value;
      if (direction === "oldest_creation_date") {
        this.sales.sort((a, b) => (a.createdDate > b.createdDate ? 1 : -1));
        this.shipment.sort((a, b) => (a.createdDate > b.createdDate ? 1 : -1));
      } else if (direction === "latest_creation_date") {
        this.sales.sort((a, b) => (a.createdDate < b.createdDate ? 1 : -1));
        this.shipment.sort((a, b) => (a.createdDate < b.createdDate ? 1 : -1));
      }
      if (direction === "oldest_shipment_date") {
        this.sales.sort((a, b) =>
          a.plannedShippingDate > b.plannedShippingDate ? 1 : -1
        );

        this.shipment.sort((a, b) =>
          a.shippingDate > b.shippingDate ? 1 : -1
        );
      } else if (direction === "latest_shipment_date") {
        this.sales.sort((a, b) =>
          a.plannedShippingDate < b.plannedShippingDate ? 1 : -1
        );

        this.shipment.sort((a, b) =>
          a.shippingDate < b.shippingDate ? 1 : -1
        );
      }
    },
    orderPipeline(event){
      this.piplineOrder = event.target.value;
    },
    shipmentCount() {
      var ret = [];
      for (let i in this.shipment) {
        let key = this.shipment[i].salesOrderNumber;
        ret[key] = {
          key: key,
          count: ret[key] && ret[key].count ? ret[key].count + 1 : 1,
        };
      }
      return Object.values(ret);
    },
    clearDateFilter(filter) {
      if (filter[0] == null && filter[1] == null) {
        this.datefilter = "";
      } else {
        return filter;
      }
    },
    deleteSalesFilter(index) {
      this.salesValue.splice(index, 1);
    },
    deleteShipmentFilter(index) {
      this.shipmentValue.splice(index, 1);
    },
    deliveryAddress(address) {
      let addressArray = [address.company,address.company2,address.street1,address.zipcode,address.city];
      let filteredAddress = addressArray.filter(function (el) {
        return el != null;
      });

     return filteredAddress.join(', ');
    },
    getNotOrderedArticle(){
      const articleNames = this.cart.map(article => article.article_name);
      return articleNames.join(', ');
    },
    checkIfSalesFilterPresent(){
      if(this.$page.props.pipelineFilter && this.salesFilter.includes(this.$page.props.pipelineFilter)){
       return [this.$page.props.pipelineFilter];
      }
      else{
        return [];
      }
    },
    checkIfPdfExists(cartitem){
      let isPdfFound = cartitem.local_article[0].media.find(item => item['collection_name'] == 'articlepdf');
      if(isPdfFound){
        return isPdfFound.original_url;
      }
    },
    valueString(array) {
      if (!array || array.length === 0) {
        return '';
      }
      return array.map(item => item.value).join(',');
    },
    handleInput(slot) {
      slot['numberValue'] = slot['numberValue'].replace(/[^0-9]/g, '');
    }
  },
  computed: {
    filteredSales() {
      const byDate = (item) => {
        const itemDate = this.convertDate(item.plannedShippingDate);

        return (
          itemDate >= this.convertDate(this.datefilter[0]) &&
          itemDate <= this.convertDate(this.datefilter[1])
        );
      };

      const byTitle = (item) => {
        let salesitems = '';
        if ( item['orderItems'].length == undefined) {
          salesitems = Object.values( item['orderItems']);
        } 
        else salesitems =  item['orderItems'];

          if(this.checkIfSalesBillOfMaterial(item,'orderItems'))
          {
            return (this.toLowerTitle(item.orderItems[0]) ||
            this.toLowerArticleNumber(item.orderItems[0]) ||
            this.toLowerTask(item));

          }
          else{
            return (
              this.toLowerTask(item) ||
              salesitems.some((it) => {
                return this.toLowerTitle(it) || this.toLowerArticleNumber(it);
              })
            );
          }
      };

      // const byTitle = (item) => {
      //   return (
      //     item.orderNumber.toLowerCase().includes(this.search.toLowerCase()) ||
      //     item.orderItems.filter((it) => {
      //       it.title.toLowerCase().includes(this.search.toLowerCase()) ||
      //         it.articleNumber
      //           .toLowerCase()
      //           .includes(this.search.toLowerCase());
      //     })
      //   );
      // };

      const bySelect = (item) => {
        if (this.salesValue.includes(item.status)) {
          return item;
        }
      };

      let results = this.sales;

      // if (this.search) {
      //   results = results.filter(byTitle);
      // }

      const hasDateFilter =
        this.datefilter?.length >= 2 &&
        this.datefilter[0] &&
        this.datefilter[1];

      if (hasDateFilter) {
        results = results.filter(byDate);
      }
      if (this.salesValue.length >= 1) {
        results = results.filter(bySelect);
      }
      if (this.search) {
        results = results.filter(byTitle);
      }

      return results;
    },
    filteredShipment() {
      const byDate = (item) => {
        const itemDate = this.convertDate(item.shippingDate);

        return (
          itemDate >= this.convertDate(this.datefilter[0]) &&
          itemDate <= this.convertDate(this.datefilter[1])
        );
      };

      const byTitle = (item) => {

        let shipmentitems = '';
        if ( item['shipmentItems'].length == undefined) {
          shipmentitems = Object.values( item['shipmentItems']);
        } 
        else shipmentitems =  item['shipmentItems'];

          if(this.checkIfSalesBillOfMaterial(item,'shipmentItems'))
          {
            return (this.toLowerTitle(item.shipmentItems[0]) ||
            this.toLowerArticleNumber(item.shipmentItems[0]) ||
            this.toLowerTask(item));
          }
          else{
            return (
              this.toLowerTask(item) ||
              shipmentitems.some((it) => {
                return this.toLowerTitle(it) || this.toLowerArticleNumber(it);
              })
            );
          }
      };



      // const byTitle = (item) => {
      //   console.log(item.salesOrderNumber);
      //   return (
      //     // item.salesOrderNumber
      //     //   .toLowerCase()
      //     //   .includes(this.search.toLowerCase()) ||
      //     item.shipmentItems.filter((it) => {
      //       it.title.toLowerCase().includes(this.search.toLowerCase()) ||
      //         it.articleNumber
      //           .toLowerCase()
      //           .includes(this.search.toLowerCase());
      //     })
      //   );
      // };

      const bySelect = (item) => {
        if (this.shipmentValue.includes(item.status)) {
          return item;
        }
      };

      let results = this.shipment;

      // if (this.search) {
      //   results = results.filter(byTitle);
      // }

      const hasDateFilter =
        this.datefilter?.length >= 2 &&
        this.datefilter[0] &&
        this.datefilter[1];

      if (hasDateFilter) {
        results = results.filter(byDate);
      }

      if (this.shipmentValue.length >= 1) {
        results = results.filter(bySelect);
      }

      if (this.search) {
        results = results.filter(byTitle);
      }

      return results;
    },
    groupedSalesAndShipmentTasks() {
      const groupedTasks = [];

      function getIdList(objects) {
        return objects.map(obj => obj.id);
      }

      // Call the function and get the ID list
      const idList = getIdList(this.filteredSales);


      idList.forEach((orderId) => {
        const salesTask = this.filteredSales.find((task) => task.id === orderId);
        const shipmentTasks = this.filteredShipment.filter((task) => task.salesOrderId === orderId);

        let salesitems='';
        if ( salesTask['orderItems'].length == undefined) {
          salesitems = Object.values( salesTask['orderItems']);
        } 
        else salesitems =  salesTask['orderItems'];

        const filteredSalesTask = salesitems.length > 0 ? salesTask : null;
        const filteredShipmentTasks = shipmentTasks.filter(task => task.shipmentItems.length > 0);

        let orderNumberAtCustomer = salesTask ? salesTask.orderNumberAtCustomer : null;

        if (filteredSalesTask || filteredShipmentTasks.length > 0) {
          groupedTasks.push({ orderId, orderNumberAtCustomer, sales: filteredSalesTask, shipments: filteredShipmentTasks });
        }
      });

       return groupedTasks;

    },
    checkIfCartItemsHavePdf(){
      return this.cart.some(cartItem => {
        const isPdfFound = cartItem.local_article[0].media.some(item => item.collection_name === 'articlepdf');
        return isPdfFound;
      }) || false;
    },
  },
  watch: {
      cart(newValue, oldValue) {
        if (newValue.length <= 0) {
          this.toggleModal();
        }
      }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>